import { PositionControls } from "./position-controls"
import { i18n } from "@/i18n";

export function WidgetPositioning() {
  return (
    <div className="cy:flex cy:flex-col cy:gap-4">
        <h2 className="cy:text-lg! cy:font-bold cy:m-0!">{i18n.__( 'Widget position', 'accessibility-widget' )}</h2>
        <PositionControls />
      </div>
  )
}
